var map = {
	"./BaseAmazonIcon.vue": "755f",
	"./BaseAnchorIcon.vue": "31a4",
	"./BaseAppleIcon.vue": "51e1",
	"./BaseArrowUpDownIcon.vue": "0a0e",
	"./BaseBellIcon.vue": "6b03",
	"./BaseBookmarkIcon.vue": "2e99",
	"./BaseBranchIcon.vue": "8b3b",
	"./BaseBriefcaseIcon.vue": "05f2",
	"./BaseCalendarIcon.vue": "4773",
	"./BaseCameraIcon.vue": "dd74",
	"./BaseCancelIcon.vue": "a190",
	"./BaseChartIcon.vue": "95db",
	"./BaseCheckIcon.vue": "9537",
	"./BaseChevronDownIcon.vue": "f377",
	"./BaseClockIcon.vue": "1563",
	"./BaseCloseIcon.vue": "8c53",
	"./BaseCloseTinyIcon.vue": "a5ae",
	"./BaseCloudIcon.vue": "6768",
	"./BaseCopyIcon.vue": "127c",
	"./BaseCursorClickIcon.vue": "a9198",
	"./BaseDesktopIcon.vue": "d02a",
	"./BaseDocumentIcon.vue": "d6d1",
	"./BaseDollarIcon.vue": "842b",
	"./BaseDoubleLeftIcon.vue": "a208",
	"./BaseDoubleRightIcon.vue": "8f74",
	"./BaseDownIcon.vue": "fa7b",
	"./BaseDownloadIcon.vue": "9755",
	"./BaseEnvelopeIcon.vue": "3c1a",
	"./BaseErrorIcon.vue": "b935",
	"./BaseExclamationIcon.vue": "9206",
	"./BaseEyeCloseIcon.vue": "e04c",
	"./BaseEyeIcon.vue": "8002",
	"./BaseFacebookIcon.vue": "2e42",
	"./BaseFilledHeartIcon.vue": "d3b5",
	"./BaseGithubIcon.vue": "d1b9",
	"./BaseGlobeIcon.vue": "c1ec",
	"./BaseGoogleColor2Icon.vue": "b788",
	"./BaseGoogleColorIcon.vue": "a96b",
	"./BaseGoogleIcon.vue": "7875",
	"./BaseGridIcon.vue": "f923",
	"./BaseHamburgerCloseIcon.vue": "67cd",
	"./BaseHamburgerIcon.vue": "7765",
	"./BaseHeartIcon.vue": "6dc1",
	"./BaseIcon.vue": "a914",
	"./BaseImageIcon.vue": "f106",
	"./BaseInfoIcon.vue": "cdb8",
	"./BaseLeftIcon.vue": "8946",
	"./BaseLinkIcon.vue": "0481",
	"./BaseLinkedinIcon.vue": "4c83",
	"./BaseLocaltionIcon.vue": "b884",
	"./BaseLockIcon.vue": "032a",
	"./BaseLogoutIcon.vue": "cd10",
	"./BaseMenu2Icon.vue": "6dd4",
	"./BaseMenuIcon.vue": "a166",
	"./BaseMessageIcon.vue": "e98c",
	"./BaseMinusIcon.vue": "3254",
	"./BaseMobileIcon.vue": "3815",
	"./BasePaperClipIcon.vue": "cde8",
	"./BasePauseIcon.vue": "760f",
	"./BasePencilIcon.vue": "3efe",
	"./BasePhoneIcon.vue": "5597",
	"./BasePlaneIcon.vue": "695c",
	"./BasePlay2Icon.vue": "6f27",
	"./BasePlayIcon.vue": "96fa",
	"./BasePlusIcon.vue": "a4ef",
	"./BaseProfileIcon.vue": "9885",
	"./BasePuzzleIcon.vue": "6d9b",
	"./BaseRefreshIcon.vue": "2078",
	"./BaseRightIcon.vue": "b38b",
	"./BaseScalesIcon.vue": "3d50",
	"./BaseSearchIcon.vue": "8f6e",
	"./BaseSettingsIcon.vue": "4710",
	"./BaseShieldIcon.vue": "28a5",
	"./BaseShoppingCartIcon.vue": "2691",
	"./BaseSpeakerPhoneIcon.vue": "59ff",
	"./BaseStarIcon.vue": "f714",
	"./BaseStarRatingIcon.vue": "ec45",
	"./BaseStripeIcon.vue": "4fd24",
	"./BaseSuccessIcon.vue": "7497",
	"./BaseSupportIcon.vue": "fce2",
	"./BaseTabletIcon.vue": "28f4",
	"./BaseTemplateIcon.vue": "f615",
	"./BaseTrashIcon.vue": "f87a",
	"./BaseTwitterIcon.vue": "02ba",
	"./BaseUnlockIcon.vue": "3ed9",
	"./BaseUpIcon.vue": "6623",
	"./BaseUploadIcon.vue": "9e57",
	"./BaseUserIcon.vue": "ce7d",
	"./BaseUserPlusIcon.vue": "03eb",
	"./BaseUsersIcon.vue": "037b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ece4";